import React, { ComponentProps } from 'react'
import { useSearchParams } from 'react-router-dom'
import * as Yup from 'yup'

import { Form } from '@newComponents/Form/Form'
import { Link } from '@newComponents/Link'
import { Text } from '@newComponents/Text'

import { XStack, YStack } from 'tamagui'

export interface FormValues {
  firstName: string
  lastName: string
  email: string
  acceptedTerms: boolean
}

interface SignUpFormProps {
  onSubmit: ComponentProps<typeof Form<FormValues>>['onSubmit']
}

const VALIDATION_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  email: Yup.string().required('Required'),
  acceptedTerms: Yup.boolean()
    .oneOf([true], 'You must accept the Terms and Privacy Policy')
    .required('You must accept the Terms and Privacy Policy'),
})

export const SignUpForm = ({ onSubmit }: SignUpFormProps) => {
  const [searchParams] = useSearchParams()

  return (
    <Form
      initialValues={
        {
          firstName: searchParams.get('firstName') || '',
          lastName: searchParams.get('lastName') || '',
          email: searchParams.get('email') || '',
          acceptedTerms: false,
        } as FormValues
      }
      onSubmit={onSubmit}
      validationSchema={VALIDATION_SCHEMA}
    >
      <YStack gap='$6'>
        <YStack gap='$6' $gtXs={{ display: 'none' }}>
          <Form.Field name='firstName' label='First Name'>
            <Form.TextInput autoFocus submitBehaviour='submit-form' />
          </Form.Field>

          <Form.Field name='lastName' label='Last Name'>
            <Form.TextInput submitBehaviour='submit-form' />
          </Form.Field>
        </YStack>

        <XStack gap='$6' display='none' $gtXs={{ display: 'flex' }}>
          <Form.Field name='firstName' label='First Name'>
            <Form.TextInput autoFocus submitBehaviour='submit-form' />
          </Form.Field>

          <Form.Field name='lastName' label='Last Name'>
            <Form.TextInput submitBehaviour='submit-form' />
          </Form.Field>
        </XStack>

        <Form.Field name='email' label='E-mail'>
          <Form.TextInput
            placeholder='Enter your e-mail address'
            inputMode='email'
            submitBehaviour='submit-form'
          />
        </Form.Field>

        <Form.Field name='acceptedTerms' label='' showError>
          <XStack gap='$3' alignItems='center' justifyContent='flex-end'>
            <Text size='$3' color='$grey7'>
              I agree to the{' '}
              <Link href='/legal/terms' size='$3' target='_blank'>
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link href='/legal/privacy' size='$3' target='_blank'>
                Privacy Policy
              </Link>
            </Text>
            <Form.Checkbox />
          </XStack>
        </Form.Field>

        <Form.SubmitButton>
          <Form.SubmitButton.Text paddingHorizontal='$4'>
            Sign Up
          </Form.SubmitButton.Text>
        </Form.SubmitButton>
      </YStack>
    </Form>
  )
}
